// extracted by mini-css-extract-plugin
export default {"wrapper":"Contact_wrapper__G8O7X","twitter":"Contact_twitter__x2dPb","logo":"Contact_logo__8KrDB","text":"Contact_text__GDqvH"};